import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class InnovationByDesign extends Base {
  static fetch(params, store) {
    const { year } = params;

    // eslint-disable-next-line radix
    if (!year || year === 'undefined' || parseInt(year) > 2018)
      return Promise.resolve(true);

    if (parseInt(year) < 2012) { // eslint-disable-line
      return Promise.reject(new Error('Invalid Year'));
    }

    // change to 2018 when api is active
    // if (cleanedYear < 2019 && cleanedYear > 2008) {
    const cleanedYear = this.cleanParam(year);
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheExpire = get(state, 'config.cacheExpire');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const host = 'assets.fastcompany.com';
    const options = {};

    const cacheKeyUrl = `https://${host}/multisite_files/fastcompany/ibd/json/details/ibd_${cleanedYear}_details.json`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
    // }
  }
}
